<template>
  <div>
    <h1>PSC {{ pscs[pscselecionado].nome }}</h1>

    <div class="texto">
      <p>
        As condições gerais para a prestação dos serviços do PSC {{ pscs[pscselecionado].nome }} estão
        descritas na DPPSC e PS, disponíveis no link abaixo.
      </p>

      <br>
    </div>

    <ul class="lista-downloads">
      <li class="prod">Prestador de Serviço de Confiança {{ pscs[pscselecionado].nome }}</li>

      <li>
        <a href="#">Situação atual:</a>
        <br>
        <span><b>{{ pscs[pscselecionado].situacao }}</b></span>
      </li>

      <li>
        <a href="#">Capacidade de armazenamento de chaves privadas</a>
        <br>
        <span><b>{{ pscs[pscselecionado].capacidade }}</b></span>
      </li>

      <li>
        <a href="#">Serviços implementados</a>
        <br>
        <span><b>{{ pscs[pscselecionado].servicos }}</b></span>
      </li>

	<li>
        <a href="#">Condições gerais</a>
        <br>
        <span>Condições gerais mediante as quais são prestados os serviços de armazenamento de chaves privadas</span>
      </li>

        <li>
        <a href="#">Armazenamento de chaves</a>
        <br>
        <span>Chaves armazenadas em dispositivos de segurança em hardware ( HSMs ) e hospedados em Salas Cofres credenciadas pelo órgão regulador.</span>
      </li>

        <li>
        <a href="#">Continuidade do serviço</a>
        <br>
        <span>Pretende continuar a prestar o serviço ou se está mediante a qualquer fiscalização dos serviços?  Prestação de serviço contínua</span>
      </li>


      <li>
        <a :href="pscs[pscselecionado].documentos.dppsc">DPPSC {{ pscs[pscselecionado].nome }}</a>
        <br>
        <span>Declaração de Práticas do Prestador de Serviço de Confiança {{ pscs[pscselecionado].nome }}</span>
      </li>

      <li>
        <a :href="pscs[pscselecionado].documentos.ps">PS {{ pscs[pscselecionado].nome }}</a>
        <br>
        <span>Política de Segurança do Prestador de Serviço de Confiança {{ pscs[pscselecionado].nome }}</span>
      </li>
    </ul>

    <ul v-if="pscs[pscselecionado].dou" class="lista-downloads">
      <li class="prod">DOU - Diário Oficial da União</li>
      <li>
        <a :href="pscs[pscselecionado].dou.link">Publicação do credenciamento do PSC {{ pscs[pscselecionado].nome }}</a>
        <span>{{ pscs[pscselecionado].dou.descricao }}</span>
      </li>
    </ul>

  </div>

</template>

<script>
import { EventBus } from '../main';

export default {
  props: [
    'pscselecionado'
  ],
  computed: {
    pscs() {
      //console.log('Computed: Repositorio pscs');
      return EventBus.pscs;
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// RepositorioPSC.vue?c2c4f796